import React from "react";
import Login from "../account/login";
import { Route,Routes } from "react-router-dom";
import Register from "../account/Register";
import Verifyemail from "../account/verifyemail";
import ForgotPassword from "../account/forgotpassword";
import Resetpassword from "../account/resetpassword";
import Home from "../home/home";
import Logout from "../account/logout"
import Onlinetest from "../home/onlinetest";
import HomeAddCandidate from "../home/homeaddcandidate";
import HomeViewFullCandidateDetailsByCandidateGUid from "../home/homeviewfullcandidatedetailsbycandidateguid";
import HomeViewPartialCandidateDetailsByCandidateGUid from "../home/homeviewpartialcandidatedetailsbycandidateguid";
import HomeViewFullInterviewCompletedCandidateDetails from "../home/homeviewfullinterviewcompletedcandidatedetails";
import HomeViewPartialInterviewCompletedCandidateDetails from "../home/homeviewpartialinterviewcompletedcandidatedetails";
import HomeViewMaskInterviewCompletedCandidateDetails from "../home/homeviewMaskinterviewcompletedcandidatedetails";
import HomeViewMaskCandidateDetailsByCandidateGUid from "../home/homeviewMaskcandidatedetailsbycandidateguid";
import TestVideo from "../home/testvideo";
import VideoPlayer from "../home/VideoPlayer";
import Viewcandidatedetailsbycandidateguid from "../home/viewallcandidatesdetailsbyclient";
import MonacoCodeEditor from "../home/screenrecorder";
import { AdminDashboard } from "../Admin/admindashboard";
import HomeViewMatchedCandidatebyId from "../home/homeviewmatchedcandidatedetails";
import SuperAdminLogin from "../home/superadminlogin";
import AIInterview from "../home/aiinterview";
import AIResumeInsights from "../home/AIResumeInsights";
import AiVerifyemail from "../home/aiverifyemail";
import ContactUs from "../home/contactus";
import HowItWorks from "../home/howitworks";
import HomeViewAssessmentVideo from "../home/homeviewassessmentvideo";
import LandingPage from "../home/landingpage";
import { CountryProvider } from "../contexts/countrycodecontext.js";
import WisperAIInterview from "../home/wisperaiinterview.js";
import Assessment from "../home/assessment.js";
import JitsiMeeting from "../home/jitsemeeting.js";
import AddBulkJobPosts from "../consultant/addbulkjobposts.js";
import HomeEditJobPost from "../home/homeeditjobposts.js";
const BeforeLoginRoutes = ()=>{
    return(
        <div>
          <CountryProvider>
<Routes>
<Route path="/" element={<LandingPage/>}/> 
     <Route path="/#LandingPage" element={<LandingPage/>}/>
      <Route path="/LandingPage" element={<LandingPage/>}/>
      <Route path="/Home" element= {<Home/>}/>
      <Route path="/Logout" element= {<Logout/>}/>
      <Route path="/Login" element= {<Login/>}/>
      <Route path="/Register" element= {<Register/>}/>
      <Route path="/ContactUS" element= {<ContactUs/>}/>
      <Route path="/HowitWorks" element= {<HowItWorks/>}/>
      <Route path="/account/VerifyEmail" element= {<Verifyemail/>}/>
      <Route path="/account/AIVerifyEmail" element= {<AiVerifyemail/>}/>
      <Route path="/account/ForgotPassword" element= {<ForgotPassword/>}/>
      <Route path="/account/ResetPassword" element= {<Resetpassword/>}/>
      <Route path="/OnlineTest" element= {<Onlinetest/>}/>
      <Route path="/CodingOnlineTest" element= {<MonacoCodeEditor/>}/>
      {/* <Route path="/AIOnlineTest" element= {<AIInterview/>}/> */}
      <Route path="/AIOnlineTest" element= {<WisperAIInterview/>}/>
       <Route path="/Assessment" element= {<Assessment/>}/>
      <Route path="/AddCandidate" element={<HomeAddCandidate />} />
      <Route path="/HomeViewFullCandidateDet" element={<HomeViewFullCandidateDetailsByCandidateGUid />} />
      <Route path="/HomeViewPartialCandidateDet" element={<HomeViewPartialCandidateDetailsByCandidateGUid />} />
      <Route path="/HomeViewFullInterviewCompletedCandidateDetails" element={<HomeViewFullInterviewCompletedCandidateDetails />} />
      <Route path="/HomeViewPartialInterviewCompletedCandidateDetails" element={<HomeViewPartialInterviewCompletedCandidateDetails />} />
      <Route path="/HomeViewMaskInterviewCompletedCandidateDetails" element={<HomeViewMaskInterviewCompletedCandidateDetails />} />
      <Route path="/HomeViewMaskCandidateDet" element={<HomeViewMaskCandidateDetailsByCandidateGUid />} />
      <Route path="/TestVideo" element={<TestVideo />} />
      <Route path="/Downloadvideo" element={<VideoPlayer />} />
      <Route path="/HomeCandidateDetails" element={<Viewcandidatedetailsbycandidateguid />} />
      <Route path="/Admin/Dashboard" element={<AdminDashboard/>} />
      <Route path="/HomeViewMatchedCandidateDetails" element={<HomeViewMatchedCandidatebyId />} />
      <Route path="/SuperAdminLogin" element={<SuperAdminLogin />} />
      <Route path="/AIResumeInsights" element={<AIResumeInsights />} />
      <Route path="/HomeViewAssessmentVideo" element={<HomeViewAssessmentVideo />} />
      <Route path="/Jitisimeeting/:roomName" element={<JitsiMeeting/>} /> 
      <Route path="/AddBulkJobPosts" element={<AddBulkJobPosts/>} /> 
      <Route path="/EditJobPost" element={<HomeEditJobPost/>} /> 

 </Routes>
 </CountryProvider>
        </div>
    )
}
export default BeforeLoginRoutes